<div class="flex flex-column align-items-center gap-0 text-center">
  <h2 class="m-1 text-primary">Solicitação enviada com sucesso.</h2>
  <h4 class="mt-0">
    Número do Atendimento: {{ dadosConfirmacao.codigoFormatado }}
  </h4>
  <span>
    O atendimento através desta plataforma é feito em horário comercial, de
    segunda à sexta, das 08h00 às 17h.
  </span>
  <span>O prazo para resposta da solicitação é de até 7 dias corridos.</span>
  <p class="font-bold">
    Para acompanhar sua solicitação
    <a href="" class="text-color-secondary no-underline" [routerLink]="
        '/servico/acompanhar/' +
        dadosConfirmacao.id +
        '/' +
        dadosConfirmacao.ano
      ">Clique Aqui</a>.
  </p>
  <p class="font-bold" *ngIf="mostrarPesquisa">
    Participe da nossa pesquisa de Satisfação.
    <a class="text-color-secondary no-underline" [routerLink]="
        '/servico/pesquisa/' + dadosConfirmacao.id + '/' + dadosConfirmacao.hash
      ">
      Clique Aqui para ser redirecionado </a>.
  </p>
  <h2>IMPORTANTE</h2>
  <p>
    Pedimos que sempre verifique a situação da sua solicitação, através do link
    acima ou através do site
    <a href="https://www.casan.com.br/" target="_blank" class="text-color-secondary no-underline">www.casan.com.br</a>,
    botão "Outros Serviços" e "Verificar Situação"
  </p>
  <p>
    Caso seu atendimento não cumpra os requisitos de documentação obrigatório
    informados anteriormente, ele será REJEITADO. E será necessário o envio de
    uma nova solicitação, com os documentos enviados inicialmente e os faltantes
    informados por e-mail.
  </p>
</div>